const BASE_URL = "https://adtwsso.klabsindia.com/api"; // Live
// const BASE_URL = "http://localhost:3033"; // Local

export default BASE_URL;